module.exports = __webpack_public_path__ + "static/media/image.1025c14f.png";